// extracted by mini-css-extract-plugin
export default {"form":"CreateBlog_form__J05bp"};